import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SettingsSection } from '@/components/features/settings/settings-section'
import { testIds } from '@/lib/test-ids'
import { getPublicHelpUrl } from '@/lib/public-site'

const HOSTED_MCP_SNIPPET = `"maater": {
  "url": "https://flownotes-mcp-production.up.railway.app/mcp"
}`

/**
 * User-level Agents tip (Account settings).
 * Hosted MCP config once; workspace extension Connect is separate.
 */
export function HostedMcpAgentsTip() {
  const [copied, setCopied] = useState(false)

  const copySnippet = async () => {
    try {
      await navigator.clipboard.writeText(HOSTED_MCP_SNIPPET)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      /* ignore */
    }
  }

  return (
    <SettingsSection
      data-testid={testIds.accountSettings.agentsMcpTip}
      title="Agents MCP (Cursor / Claude)"
      description={
        <>
          Hosted MCP in your IDE authenticates you to Maater (user-level, once).
          Extension tools still need Connect on each workspace that uses them
          (for example Basecamp Connect for{' '}
          <code className="text-[11px]">basecamp_update_todo</code>).
          Cursor MCP OAuth does not replace workspace Connect.
        </>
      }
    >
      <div className="space-y-2">
        <p className="text-xs font-medium text-muted-foreground">
          Cursor <code className="text-[11px]">~/.cursor/mcp.json</code>
        </p>
        <pre className="text-[11px] leading-relaxed rounded-md bg-background/80 border border-border/50 p-3 overflow-x-auto font-mono whitespace-pre">
          {HOSTED_MCP_SNIPPET}
        </pre>
        <div className="flex flex-wrap items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 text-xs"
            onClick={copySnippet}
          >
            {copied ? (
              <Check className="h-3.5 w-3.5 mr-1" />
            ) : (
              <Copy className="h-3.5 w-3.5 mr-1" />
            )}
            {copied ? 'Copied' : 'Copy snippet'}
          </Button>
          <span className="text-xs text-muted-foreground">
            Prefer bare <code className="text-[11px]">url</code> (no Authorization header) so Cursor can OAuth.
            After edit: MCP settings - toggle off/on.
          </span>
          <a
            href={getPublicHelpUrl('mcp')}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-primary underline-offset-2 hover:underline"
            data-testid={testIds.accountSettings.agentsMcpGuideLink}
          >
            Full connect guide
          </a>
        </div>
      </div>
    </SettingsSection>
  )
}
